"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderPaymentIntent = void 0;
const class_validator_1 = require("class-validator");
/**
 * Represents a payment intent associated with a sales order, detailing the
 * payment ID, the amount in cents, and the currency used.
 */
class SalesOrderPaymentIntent {
    constructor(data) {
        this.clientSecret = data.clientSecret;
        this.intentId = data.intentId;
        this.amountCents = data.amountCents;
        this.currency = data.currency;
    }
    serialize() {
        return {
            intentId: this.intentId,
            clientSecret: this.clientSecret,
            amountCents: this.amountCents,
            currency: this.currency
        };
    }
    static unserialize(data) {
        return new SalesOrderPaymentIntent(data);
    }
}
__decorate([
    (0, class_validator_1.IsString)()
], SalesOrderPaymentIntent.prototype, "intentId", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], SalesOrderPaymentIntent.prototype, "clientSecret", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], SalesOrderPaymentIntent.prototype, "amountCents", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], SalesOrderPaymentIntent.prototype, "currency", void 0);
exports.SalesOrderPaymentIntent = SalesOrderPaymentIntent;
//# sourceMappingURL=SalesOrderPaymentIntent.js.map